import {
  EventrDate,
  isIEventrActivity,
  isIEventrFlight,
  isIEventrHireCar,
  isIEventrHotel,
  isIEventrParking,
  isIEventrTransport,
  TItineraryEntry,
} from "@eventr/common";
import { ActivityCard } from "./activityCard";
import { FlightCard } from "./flightCard";
import HireCarCard from "./hireCarCard";
import HotelCard from "./hotelCard";
import ParkingCard from "./parkingCard";
import { TodoCard } from "./todoCard";
import TransportCard from "./transportCard";

export function CardLocator({ data, date }: { data: TItineraryEntry; date?: string | undefined }) {
  if (isIEventrActivity(data) && data.type === "todo") return <TodoCard id="todo" todo={data} />;
  if (isIEventrActivity(data)) return <ActivityCard data={data} date={date} />;
  if (isIEventrTransport(data)) return <TransportCard data={data} date={date} />;
  if (isIEventrFlight(data)) return <FlightCard data={data} date={date} />;
  if (isIEventrHotel(data)) return <HotelCard data={data} date={date} />;
  if (isIEventrHireCar(data)) return <HireCarCard data={data} date={date} />;
  if (isIEventrParking(data)) return <ParkingCard data={data} />;
  return null;
}

export const isSameDay = (dateA: string, dateB: string) =>
  new EventrDate(dateA).toItinLocalDateString() === new EventrDate(dateB).toItinLocalDateString();

export const isPastDate = (date: string) => new EventrDate(date).getUnixMs < new EventrDate().getUnixMs;
